import React, { useRef, useEffect } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { createPortal } from 'react-dom';
import './ContextMenu.scss';

const ContextMenu = (props) => {
  const triggerRef = useRef(null);
  const menuRef = useRef(null);

  useEffect(() => {
    if (!props.isOpen) return;

    const handleClickOutside = (event) => {
      if (
        menuRef.current &&
        !menuRef.current.contains(event.target) &&
        triggerRef.current &&
        !triggerRef.current.contains(event.target)
      ) {
        props.closeMenu();
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    // eslint-disable-next-line consistent-return
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [props.isOpen]);

  return (
    <div
      className={classnames('context-menu', props.className, { 'is-open': props.isOpen })}
      style={{ display: 'inline-block', position: 'relative' }}
    >
      <button
        ref={triggerRef}
        type="button"
        className={classnames('context-menu__trigger', props.labelClassName)}
        onClick={props.handleClick}
        aria-haspopup="true"
        aria-expanded={props.isOpen}
      >
        {props.label}
      </button>
      {props.isOpen &&
        createPortal(
          <div
            ref={menuRef}
            className="context-menu__menu"
            role="menu"
            style={{
              '--top-offset': `${triggerRef.current.getBoundingClientRect().top + 32}px`,
            }}
          >
            {React.Children.map(props.children, (child) =>
              child ? (
                <div role="menuitem" tabIndex={-1} key={child.key || undefined} className="context-menu__item">
                  {child}
                </div>
              ) : null
            )}
          </div>,
          document.body
        )}
    </div>
  );
};

ContextMenu.propTypes = {
  children: PropTypes.node.isRequired,
  className: PropTypes.string,
  label: PropTypes.node,
  labelClassName: PropTypes.string,
  handleClick: PropTypes.func.isRequired,
  isOpen: PropTypes.bool.isRequired,
  closeMenu: PropTypes.func.isRequired,
};

ContextMenu.defaultProps = {
  className: '',
  label: 'More',
  labelClassName: '',
};

export default ContextMenu;
